import { useEffect, useState } from 'react';
import './App.css';
import Selector from './components/selector/Selector';
import Image from './components/image/Image';
import { COLORS, FUENTES } from './utils';

const App = () => {
    const [name, setName] = useState('Nombre');
    const [lastName, setLastName] = useState('');
    const [maxLength1, setMaxLength1] = useState('');
    const [maxLength2, setMaxLength2] = useState('');
    const [font, setFont] = useState(null);
    const [color, setColor] = useState(null);
    const [design, setDesign] = useState(null);
    const [hideColorSelector, setHideColorSelector] = useState(false);
    const [hideFontSelector, setHideFontSelector] = useState(false);
    const [error, setError] = useState(null);

    const getError = (error) => {
        if (!error) return;
        setError(error);
    };

    const getDesign = (design) => {
        if (!design) return;
        setDesign(design);
        setHideColorSelector(design.hideColorSelector);
        setHideFontSelector(design.hideFontSelector);
        if (design.iniciales) {
            setName((prev) => (prev === 'Nombre' || prev === 'ABC' || prev === '' ? 'ABC' : prev));
            setLastName('');
        } else {
            setName((prev) => (prev === 'ABC' || prev === '' ? 'Nombre' : prev));
        }
    };

    const getText = (text) => {
        if (!text) return;
        switch (text.name) {
            case 'name':
                setName(text.value);
                break;
            case 'lastName':
                setLastName(text.value);
                break;
            case 'color':
                setColor(text.value);
                break;
            case 'font':
                setFont(text.value);
                break;
            case 'maxLength1':
                setMaxLength1(text.value);
                break;
            case 'maxLength2':
                setMaxLength2(text.value);
                break;
            default:
                return false;
        }
    };

    useEffect(() => {
        if (window.location.hostname === 'localhost') return;

        if (!color) {
            const defaultValue = COLORS.find((color) => {
                return color.hex === design?.defaultColor;
            });
            setColor(defaultValue?.name);
        }
        if (!font) {
            const defaultValue = FUENTES.find((font) => {
                return font.value === design?.defaultTypography;
            });
            setFont(defaultValue?.value);
        }

        if (design && name && font && color) {
            setError(null);
        } else {
            setError('missing data');
        }

        window.parent.postMessage(
            {
                color,
                design: design ? design.name : '',
                error,
                font,
                hideColorSelector,
                hideFontSelector,
                iniciales: !!design?.iniciales,
                lastName,
                maxLength1,
                maxLength2,
                name,
            },
            'https://etiquettediseno.com/*',
        );
    }, [design, name, lastName, maxLength1, maxLength2, font, color, hideColorSelector, hideFontSelector, error]);

    return (
        <div className="grid lg:grid-cols-2 gap-4 mx-auto mb-10">
            <Image design={design} name={name} lastName={lastName} color={color} font={font} />
            <Selector getDesign={getDesign} getText={getText} getError={getError} />
        </div>
    );
};

export default App;
